import { Check } from "lucide-react";

import { ResponsiveImage } from "@/components/site/ResponsiveImage";
import { Reveal } from "@/components/site/Reveal";
import { business } from "@/lib/business";
import { imageSizes, machinistImage } from "@/lib/images";

const points = [
  "Open since January 1, 2016 with over 10 years of machining experience",
  "All machine work guaranteed to your satisfaction",
  "Clear communication — you always know what your engine needs and why",
  "Trusted by homeowners, repair shops, businesses and tractor companies",
];

export function About() {
  return (
    <section
      id="about"
      className="scroll-mt-28 border-b border-border py-20 sm:py-28"
      aria-labelledby="about-heading"
    >
      <div className="mx-auto grid max-w-6xl items-center gap-12 px-4 lg:grid-cols-2">
        <Reveal variant="image" className="relative rounded-lg">
          <ResponsiveImage
            image={machinistImage}
            alt="Machinist measuring a crankshaft journal with a micrometer"
            sizes={imageSizes.portrait}
            imgClassName="w-full rounded-lg border border-border object-cover"
            style={{ boxShadow: "var(--shadow-hard)" }}
          />
          <div className="surface-card absolute right-4 bottom-4 px-5 py-3 sm:-right-6">
            <p className="font-display text-4xl text-primary-text">10+</p>
            <p className="text-xs tracking-widest uppercase text-muted-foreground">
              Years experience
            </p>
          </div>
        </Reveal>

        <div>
          <Reveal variant="right">
            <p className="eyebrow">About us</p>
            <h2 id="about-heading" className="mt-3 text-4xl uppercase sm:text-5xl">
              A shop you can hand your engine to
            </h2>
            <p className="mt-5 text-muted-foreground">
              Champion Automotive Machine Shop is a family-run machine shop in {business.city},
              Alabama, owned and operated by {business.owner}. Since {business.since} we've rebuilt
              and reconditioned engines for drivers, farmers, fleets and repair shops across the
              Wiregrass — restoring performance and reliability with careful, measured machine work.
            </p>
            <p className="mt-4 text-muted-foreground">
              Most people who call us have been burned before, or simply don't know who to trust
              with an expensive block. We keep it simple: honest assessments, real communication,
              and machine work guaranteed to your satisfaction.
            </p>
          </Reveal>

          <ul className="mt-8 grid gap-3">
            {points.map((point, index) => (
              <Reveal key={point} as="li" delay={120 + index * 80} variant="right">
                <div className="flex gap-3 text-sm">
                  <Check className="mt-0.5 size-5 shrink-0 text-primary-text" aria-hidden="true" />
                  <span>{point}</span>
                </div>
              </Reveal>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
